import { getField, updateField } from "vuex-map-fields";

const getDefaultState = () => {
  return {
    RBF0404A40: {}, //거래내역조회 결과
    RBF0404E40: {}, //수표거래내역조회 결과
    chekNo: "", //수표번호
  };
};

const bnkChekInq = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
  },
  mutations: {
    updateField,
    resetState: state => {
      Object.assign(state, getDefaultState());
    },
  },
  actions: {},
};

export default bnkChekInq;
